<div class="justification" *transloco="let t; read: 'building.control'">
  <div class="short-details">
    @if (!isOpen) {
    <div (click)="onToggleDetailsClick()" class="details clickable">
      @if (compliance.proofs.length > 0) {
      <p>
        {{ compliance.proofs[0] }}
        @if (compliance.proofs.length > 1) {
        <span>(+{{ compliance.proofs.length }})</span>
        }
      </p>
      } @if (compliance.description) {
      <p>{{ compliance.description }}</p>
      }
    </div>
    } @if (!isOpen) {
    <mat-icon class="clickable" (click)="onToggleDetailsClick()" data-testid="open-details">keyboard_arrow_down</mat-icon>
    }
  </div>

  @if (isOpen) {
  <div class="long-details" data-testid="long-details">
    <div class="close-details-wrapper">
      @if (isOpen) {
      <mat-icon class="clickable" (click)="onToggleDetailsClick()" data-testid="close-details">keyboard_arrow_up</mat-icon>
      }
    </div>
    <div>
      @if (compliance.description) {
      <mat-form-field data-testid="note">
        <mat-label class="capitalized">{{ t('defectsCompliance.note') }}</mat-label>
        <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="10" disabled>{{
          compliance.description
        }}</textarea>
      </mat-form-field>
      } @if (compliance.proofs.length > 0) {
      <fieldset data-testid="proofs">
        <legend>{{ t('defectsCompliance.documents') }}</legend>
        <mat-chip-listbox>
          @for (proof of compliance.proofs; track proof) {
          <sibat-chip-proof [proofName]="proof" (downloaded)="downloadComplianceProof(proof)"> </sibat-chip-proof>
          }
        </mat-chip-listbox>
      </fieldset>
      }
    </div>
  </div>
  }
</div>
